import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id E9237D99-5BD3-434A-B574-97C60B544EE1
 * name decimal-comma-decrease
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/decimal-comma-decrease.svg
 * tags
 * - Math 
 */
export const DecimalCommaDecreaseIcon = createSvgIcon(<><path d="M5 13V16H4L3 13A1 1 0 0 1 5 13M15 16V14L12 17L15 20V18H21V16M12 11A3 3 0 0 1 6 11V8A3 3 0 0 1 12 8M10 8A1 1 0 0 0 8 8V11A1 1 0 0 0 10 11Z" /></>, 'DecimalCommaDecreaseIcon');
export default DecimalCommaDecreaseIcon